import React, { useEffect, useState } from "react";
import "./ReferenceList.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Api } from "../../../../Admin/BackendApi/api";
import { FaSortAmountDown } from "react-icons/fa";
import SortModal from "../../../Component/SortModal/SortModal";
import { APP_VERSION } from "../../../../Admin/Pages/Version Provider/VersionConfig";
import ConfirmPopup from "../../../../Admin/Component/ConfirmPopup/ConfirmPopup";

const ReferenceList = () => {
    const navigate = useNavigate();

    const [references, setReferences] = useState([]);
    const [sortColumn, setSortColumn] = useState("CustName");
    const [sortOrder, setSortOrder] = useState(-1);
    const [isSortOpen, setIsSortOpen] = useState(false);

    const [versionCode] = useState(APP_VERSION);

    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "error",
    });

    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    const colors = ["#E3DFFF", "#FFD8D8", "#D8EEFF", "#FFE5C7", "#D8FFD8"];

    const fetchReferences = async () => {
        try {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/user/login");
                return;
            }

            const response = await axios.post(
                Api.getReference,
                {
                    VersionCode: versionCode,
                    sort_column: sortColumn,
                    sort_order: sortOrder,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            if (response.data.status === 0) {
                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {response.data.message}
                        </>
                    ),
                    type: "error",
                });

                return;
            }

            if (response.data.status === 1) {
                setReferences(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching references:", error);

            setPopup({
                show: true,
                message: "Server error. Try again.",
                type: "error",
            });
        }
    };

    useEffect(() => {
        fetchReferences();
    }, [sortColumn, sortOrder]);

    return (
        <div className="user-references-container">
            <div
                onClick={() => setIsSortOpen(true)}
                style={{
                    backgroundColor: "#704A94",
                    padding: "8px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    width: "fit-content",
                    marginLeft: "auto",
                    marginBottom: "10px",
                }}
            >
                <FaSortAmountDown color="white" />
            </div>

            <SortModal
                isOpen={isSortOpen}
                onClose={() => setIsSortOpen(false)}
                onApply={(col, order) => {
                    setSortColumn(col);
                    setSortOrder(order === "asc" ? 1 : -1);
                }}
                currentColumn={sortColumn}
                currentOrder={sortOrder === 1 ? "asc" : "desc"}
                columns={[
                    { label: "Name", value: "CustName" },
                    { label: "MobileNo", value: "CustMobile" },
                    { label: "Date", value: "CreatedAt" },
                ]}
            />

            <div className="user-references-scroll">
                {references.map((ref, index) => {
                    const initials = ref.CustName
                        ? ref.CustName.split(" ")
                              .map((n) => n[0])
                              .join("")
                        : "";

                    return (
                        <div className="user-reference-card" key={ref._id}>
                            <div
                                className="ref-card-left"
                                style={{
                                    backgroundColor:
                                        colors[index % colors.length],
                                }}
                            >
                                {initials}
                            </div>

                            <div className="ref-card-content">
                                <div className="ref-name">{ref.CustName}</div>
                                <div className="ref-info">
                                    Mobile: {ref.CustMobile}
                                </div>
                                <div className="ref-info">
                                    Address: {ref.CustAddress}
                                </div>
                                <div className="ref-info">
                                    Date:{" "}
                                    {new Date(
                                        ref.CreatedAt,
                                    ).toLocaleDateString()}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />
        </div>
    );
};

export default ReferenceList;
